export const createId = () => {
  const cryptoApi = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;

  if (cryptoApi?.randomUUID) {
    return cryptoApi.randomUUID();
  }

  if (cryptoApi?.getRandomValues) {
    const bytes = new Uint8Array(16);
    cryptoApi.getRandomValues(bytes);

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    return [...bytes]
      .map((byte, index) => `${index === 4 || index === 6 || index === 8 || index === 10 ? '-' : ''}${byte.toString(16).padStart(2, '0')}`)
      .join('');
  }

  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
};

// Field Types
export const FIELD_TYPES = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  CHECKBOX_GROUP: 'checkbox-group',
  DATE: 'date',
  TIME: 'time',
  TABLE: 'table',
  NUMBER: 'number',
  EMAIL: 'email',
  LABEL: 'label'
};

// Form Status
export const FORM_STATUS = {
  DRAFT: 'draft',
  COMPLETED: 'completed',
  ARCHIVED: 'archived'
};

// Example field structure
export const createField = (type, overrides = {}) => {
  const isLabel = type === FIELD_TYPES.LABEL;

  return {
    id: createId(),
    type,
    label: '',
    name: isLabel ? undefined : '',
    placeholder: isLabel ? undefined : '',
    required: false,
    options: type === FIELD_TYPES.SELECT || type === FIELD_TYPES.CHECKBOX_GROUP ? [] : undefined,
    columns: type === FIELD_TYPES.TABLE ? [
      { key: 'col1', label: 'Column 1', type: 'text' },
      { key: 'col2', label: 'Column 2', type: 'text' },
      { key: 'col3', label: 'Column 3', type: 'text' }
    ] : undefined,
    defaultValue: isLabel ? undefined : '',
    ...overrides,
    ...(isLabel ? { name: undefined, placeholder: undefined, required: false, options: undefined, columns: undefined, defaultValue: undefined } : {}),
  };
};

// Example section structure
export const createSection = (title = 'New Section') => ({
  id: createId(),
  title,
  icon: '',
  fields: []
});

// Example template structure
export const createTemplate = (name = 'New Template') => ({
  id: createId(),
  name,
  description: '',
  category: 'interview',
  sections: [],
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
});

// Example client structure
export const createClient = (name = '') => ({
  id: createId(),
  name,
  location: '',
  contactName: '',
  contactEmail: '',
  contactPhone: '',
  notes: '',
  createdAt: new Date().toISOString()
});

// Example form instance structure
export const createFormInstance = (templateId, clientId) => ({
  id: createId(),
  templateId,
  clientId,
  title: '',
  status: FORM_STATUS.DRAFT,
  data: {},
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  completedAt: null
});

